<template>
  <div class="footer">
    <div class="f_bg">
      <div class="f_ctfl"></div>
      <div class="back" @click="backtop">
        <div class="back_bg"></div>
        <div class="back_top">back to top</div>
      </div>
    </div>

    <div class="inner">
      <div class="inner_left">
        <div class="logo"></div>
        <div class="tel_box">
          <div class="tel" v-for="(ele, n) in telList" :key="n">
            <div class="tel_class">{{ ele.name }}</div>
            <div class="tel_no">{{ ele.no }}</div>
          </div>
        </div>
        <div class="ad_eml">
          <div class="adress">
            总部地址：重庆市两江新区黄山大道中段7号木星科技大厦（14、15楼）
          </div>
          <div class="adress">
            成都办事处地址：四川省成都市锦江区人民南路二段
            1号仁恒置地广场写字楼20楼
          </div>
          <div class="eml">邮箱：<span>ctfl@ctfleasing.com</span></div>
        </div>
      </div>

      <div class="inner_right">
        <div class="itembox" v-for="(ele, n) in list" :key="n + 'm'">
          <div class="item_title">{{ ele.title }}</div>
          <div class="item_text" v-for="(elm, m) in ele.item" :key="m + 'n'">
            <a
              :href="elm.url"
              target="_blank"
              v-if="elm.name == '懂车商官网'"
              >{{ elm.name }}</a
            >
            <router-link v-else :to="elm.url"
              ><span @click="toptop">{{ elm.name }}</span></router-link
            >
          </div>
        </div>
      </div>
    </div>

    <div class="yaba">
      <a href="https://beian.mps.gov.cn/#/query/webSearch"
        >渝公网安备50019002502736号</a
      >
      丨
      <a href="https://beian.miit.gov.cn/#/Integrated/index"
        >渝ICP备17011311号-2</a
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      telList: [
        { name: "客服热线：", no: "400 6230963" },
        { name: "汽车金融客服热线：", no: "023-8571 7204" },
      ],
      list: [
        {
          title: "关于华科",
          item: [
            { name: "公司概况", url: "/aboutHK/introduce?deep=900" },
            { name: "企业文化", url: "/aboutHK/enterpriseCul?deep=900" },
            { name: "大事记", url: "/aboutHK/events?deep=900" },
            { name: "经典案例", url: "/aboutHK/case?deep=901" },
            { name: "社会荣誉", url: "/aboutHK/social?deep=905" },
          ],
        },
        {
          title: "业务领域",
          item: [
            { name: "产业金融", url: "/business?active1=1&deep=1350" },
            { name: "汽车金融", url: "/business?active1=2&deep=1300" },
            { name: "股权投资", url: "/business?active1=3&deep=1300" },
            { name: "咨询顾问", url: "/business?active1=4&deep=1300" },
            { name: "商业保理", url: "/business?active1=5&deep=1300" },
            { name: "跨境融资", url: "/business?active1=6&deep=1300" },
          ],
        },
        {
          title: "新闻资讯",
          item: [{ name: "新闻资讯", url: "/news?active1=1&deep=900" }],
        },
        {
          title: "数字金融",
          item: [
            { name: "易租系统", url: "/digitization?deep=2300" },
            { name: "征信系统", url: "/digitization?deep=3100" },
            { name: "业财税一体化", url: "/digitization?deep=3900" },
            { name: "新数软", url: "/digitization?deep=4700" },
            { name: "懂车商", url: "/digitization?deep=5500" },
            { name: "科技成果", url: "/digitization?deep=6380" },
          ],
        },
        {
          title: "联系我们",
          item: [
            { name: "人才招聘", url: "/contactUs?active1=1&deep=900" },
            { name: "联系方式", url: "/contactUs?active1=2&deep=900" },
          ],
        },
        {
          title: "友情链接",
          item: [
            { name: "华科产融", url: "/fundcompany" },
            { name: "新数软", url: "/newSR" },
            { name: "懂车商官网", url: "https://dongcs.com/#/" },
          ],
        },
      ],
    };
  },
  methods: {
    backtop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    toptop() {
      window.scrollTo({
        top: 900,
        behavior: "instant",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 780px;
  background: #f5f5f5;
  position: relative;
  text-align: left;
  color: #1c1c1c;
  font-family: Source Han Sans CN, Source Han Sans CN;
}

.f_ctfl {
  width: 1190px;
  height: 336px;
  background: url("../assets//footer/CTFL.png") no-repeat;
  background-size: 1190px 336px;
  position: absolute;
  right: 332px;
  top: 184px;
}
.back {
  width: 297px;
  height: 312px;
  position: absolute;
  right: 10px;
  bottom: 103px;
  z-index: 9;
  cursor: pointer;
  .back_bg {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 297px;
    height: 210px;
    background: url("../assets/footer/back2.png") no-repeat;
    background-position: top center;
  }
  .back_top {
    width: 180px;
    height: 40px;
    line-height: 40px;
    font-family: MessapiaBlod, sans-serif;
    font-size: 20px;
    color: #1c1c1c;
    position: absolute;
    right: calc(50% - 90px);
    bottom: 20px;
  }
}

.inner {
  position: absolute;
  right: calc(50% - 870px);
  top: 100px;
  width: 1740px;
  height: 580px;
  border-bottom: #dcdcdc 1px solid;
  margin: auto;
  display: flex;
}

.inner_left {
  width: 600px;
  height: 100%;
  .logo {
    width: 151px;
    height: 51px;
    background: url("../assets/footer/logo.png") no-repeat;
    background-size: 152px 51px;
  }
  .tel_box {
    margin-top: 70px;
    height: 250px;
    .tel {
      margin-top: 20px;
    }
    .tel_class {
      font-weight: 400;
      font-size: 15px;
    }
    .tel_no {
      font-family: MessapiaBlod, sans-serif;
      font-size: 24px;
      line-height: 50px;
    }
  }
  .ad_eml {
    margin-top: 105px;
    .adress,
    .eml {
      font-size: 15px;
      line-height: 30px;
    }
    span {
      font-family: MessapiaBlod, sans-serif;
      font-size: 18px;
    }
  }
}

.inner_right {
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: space-between;
  text-align: center;

  .itembox {
    width: 120px;
    height: 280px;
  }
  .item_title {
    font-weight: bold;
    font-size: 16px;
  }
  .item_text {
    font-weight: 400;
    font-size: 14px;
    margin-top: 28px;
    cursor: pointer;
  }
}

.yaba {
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 15px;
  color: #929292;
  line-height: 78px;
  text-align: center;
  cursor: pointer;
}

a {
  color: #1c1c1c;
  text-decoration: none;
}

a:hover {
  color: #c71723;
}

@keyframes xuanzhuan {
  0% {
    transform: rotate(0deg);
  }
  20% {
    transform: rotate(20deg);
  }
  40% {
    transform: rotate(0deg);
  }
  70% {
    transform: rotate(-30deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>